module.exports = __webpack_public_path__ + "static/img/304.ec30a702.jpg";